import {
  $AjaxJson
} from '../lf'
import {
  $Urlpath,
  $UrlApipath
} from '../config/config'


export const userRequest = {
  login(func, obj) {
    $AjaxJson($UrlApipath + "Account/Login", obj, function (d) {
      func(d)
    })

  },
  Sendmessagepassword(func, obj) {
    $AjaxJson($UrlApipath + "Account/Sendmessagepassword", obj, function (d) {
      func(d)
    })

  },
  Register(func, obj) {
    $AjaxJson($UrlApipath + "Account/Register", obj, function (d) {
      func(d)
    })
  },
  HomepageQueryData(func, ID) {
    $AjaxJson($UrlApipath + "Warehouse/HomepageQueryData", {ID:ID}, function (d) {
      func(d)
    })
  },
  ToCustomerAccount(func, obj) {
    $AjaxJson($UrlApipath + "Account/ToCustomerAccount", obj, function (d) {
      func(d)
    })
  },
  GetUserRights(func, obj) {
    $AjaxJson($UrlApipath + "User/GetUserRights", obj, function (d) {
      func(d)
    }, true)
  },
  GetMyUser(func) {
    $AjaxJson($UrlApipath + "User/GetMyUser", {}, function (d) {
      func(d)
    })
  },
  GetNotice(func) {
    $AjaxJson($UrlApipath + "User/GetNotice", {}, function (d) {
      func(d)
    })
  },

  GetUser(func, ID) {
    $AjaxJson($UrlApipath + "User/GetUser", {
      ID: ID
    }, function (d) {
      func(d)
    })
  },

  GetUserCustomer(func, ID) {
    $AjaxJson($UrlApipath + "User/GetUserCustomer", {
      ID: ID
    }, function (d) {
      func(d)
    })
  },

  MarkingOrder(func, d) {
    $AjaxJson($UrlApipath + "User/MarkingOrder", d, function (d) {
      func(d)
    })
  },
  SetRefID(func, d) {
    $AjaxJson($UrlApipath + "User/SetRefID", d, function (d) {
      func(d)
    })
  },
  CreditFee(func, d) {
    $AjaxJson($UrlApipath + "User/CreditFee", d, function (d) {
      func(d)
    })
  },
  SetCommission(func, obj) {
    $AjaxJson($UrlApipath + "User/SetCommission", obj, function (d) {
      func(d)
    })
  },

  AddUser(func, obj) {
    $AjaxJson($UrlApipath + "User/AddUser", obj, function (d) {
      func(d)
    })
  },
  UpdateUser(func, obj) {
    $AjaxJson($UrlApipath + "User/UpdateUser", obj, function (d) {
      func(d)
    })
  },
  UpdateUserCustomer(func, obj) {
    $AjaxJson($UrlApipath + "User/UpdateUserCustomer", obj, function (d) {
      func(d)
    })
  },
  EmailTest(func, obj, Title, ToEmail,Remark) {
    $AjaxJson($UrlApipath + "User/EmailTest",

      {
        data: obj, Title: Title, ToEmail: ToEmail,Remark:Remark
      }
      , function (d) {
        func(d)
      })
  },
  SearchUser(func, obj) {
    $AjaxJson($UrlApipath + "User/SearchUser", obj, function (d) {
      func(d)
    })
  },


  SetUserType(func, UserID, UserType) {
    $AjaxJson($UrlApipath + "User/SetUserType", {
      UserType: UserType,
      ID: UserID,
    }, function (d) {
      func(d)
    })
  },
  SetUserStatus(func, UserID, Status) {
    $AjaxJson($UrlApipath + "User/SetUserStatus", {
      Status: Status,
      ID: UserID,
    }, function (d) {
      func(d)
    })
  },
  SetUserIsSalesUser(func, UserID, IsSalesUser) {
    $AjaxJson($UrlApipath + "User/SetUserIsSalesUser", {
      IsSalesUser: IsSalesUser,
      ID: UserID,
    }, function (d) {
      func(d)
    })
  },

  SetUserAutherized(func, UserID, Autherized, AuditNotes) {
    $AjaxJson($UrlApipath + "User/SetUserAutherized", {
      Autherized: Autherized,
      AuditNotes: AuditNotes,
      UserID: UserID,
    }, function (d) {
      func(d)
    })
  },

  ResetUserListPassword(func, userIDs, newPassword) {
    $AjaxJson($UrlApipath + "User/ResetUserListPassword", {
      userIDs: userIDs,
      newPassword: newPassword,
    }, function (d) {
      func(d)
    })
  },


  ResetUserPassword(func, userName,newPassword,) {
    $AjaxJson($UrlApipath + "Account/ChangeUserPassword", {
      userName: userName,
     
      newPassword: newPassword,
    }, function (d) {
      func(d)
    })
  },

  ChangeUserPassword(func, oldPassword,newPassword,) {
    $AjaxJson($UrlApipath + "User/ChangeUserPassword", {
      oldPassword: oldPassword,
      newPassword: newPassword,
    }, function (d) {
      func(d)
    })
  },


  SetUsersAccountCreditAndGuarantee(func, UserID, Credit, Guarantee) {
    $AjaxJson($UrlApipath + "User/SetUsersAccountCreditAndGuarantee", {
      Credit: Credit,
      Guarantee: Guarantee,
      UserID: UserID,
    }, function (d) {
      func(d)
    })
  },


  SetUsersAccountCurrencyID(func, UserID, CurrencyID) {
    $AjaxJson($UrlApipath + "User/SetUsersAccountCurrencyID", {
      CurrencyID: CurrencyID,
      UserID: UserID,
    }, function (d) {
      func(d)
    })
  },




}



// WEBPACK FOOTER //
// ./src/request/user.js